import { render, staticRenderFns } from "./ModalForSignDocument.vue?vue&type=template&id=641b8123&"
import script from "./ModalForSignDocument.vue?vue&type=script&lang=js&"
export * from "./ModalForSignDocument.vue?vue&type=script&lang=js&"
import style0 from "./ModalForSignDocument.vue?vue&type=style&index=0&id=641b8123&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports